import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/signature.jpeg'


const _hoisted_1 = { class: "logo mb-24 item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "we_company_address_detail item" }
const _hoisted_4 = { class: "mb-12 weight_700_font" }
const _hoisted_5 = { class: "invoice_title weight_700_font item" }
const _hoisted_6 = { class: "flex_align_center_item invoice_company_detail mb-48 item" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = { class: "mr-8 weight_700_font" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "mr-8 weight_700_font" }
const _hoisted_11 = { class: "invoice_table mb-48 item" }
const _hoisted_12 = { style: { 'table-layout': 'fixed' } }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "save_space" }
const _hoisted_15 = { class: "invoice_we_company_detail" }
const _hoisted_16 = { class: "mr-8" }
const _hoisted_17 = { class: "seal_container" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "signature" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_19 = { class: "seal ml-8" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "more item mb-48"
}
const _hoisted_22 = { class: "label mr-24" }
const _hoisted_23 = { class: "currency mr-24" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = {
  key: 1,
  class: "item weight_700_font footer",
  style: {"font-size":"16px"}
}

import { computed, ref } from 'vue';
  import { cloneDeep } from 'lodash';
  import dayjs from 'dayjs';
  import { add_pdf, get_invoice_template_list, get_invoice_template_detail } from '@/api/erp-invoice';
  import { formatNumberByNumeral, isEmptyData } from '@/utils/common';
  import { outPutPdf } from '@/utils/canvas_to_pdf';
  import { useAppInfo } from '@/hooks/useAppInfo';

  
export default /*#__PURE__*/_defineComponent({
  props: {
    invoice: { default: () => ({}) },
    neutralize_reason: { default: '' },
    showBuline: { default: false },
    company_name: { default: '' },
    logic_type: { default: 0 }
  },
  emits: ['add_pdf_done'],
  setup(__props: any, { expose, emit }) {

const props = __props as { invoice: Recordable, neutralize_reason: string, showBuline: boolean, company_name: string, logic_type: number }

  const table_fields = [
    {
      text: 'No',
      value: 'no',
      width: '40px',
    },
    {
      text: 'Description',
      value: 'description',
    },
    {
      text: 'Amount',
      value: 'rd_amount',
      width: '200px',
    },
    {
      text: 'Net amount before GST',
      value: 'rd_net_amount_before_gst',
      width: '200px',
    },
    {
      text: 'GST Rate',
      value: 'gst_rate',
      width: '80px',
    },
    {
      text: 'GST Amount',
      value: 'rd_gst_amount',
      width: '180px',
    },
  ];

  

  const { apiRoot, model, appInfo } = useAppInfo();

  const visible = ref(false);
  const invoice_template_list = ref<Recordable[]>([]);
  const invoice_template_detail = ref<Recordable[]>([]);

  

  const fields = computed(() => {
    return [
      {
        text: 'Billed to',
        value: 'company_name',
        get_value: () => {
          return props.company_name;
        },
        style: {
          'font-weight': 700,
        },
      },
      {
        text: 'Invoice No',
        value: 'invoice_number',
      },
      {
        text: 'Address',
        value: 'cs_address',
      },
      {
        text: 'Invoice Date',
        value: 'date',
        get_value() {
          return dayjs(props.invoice.date).format('YYYY-MM-DD');
        },
      },
      {
        text: 'Due Date',
        value: 'due_date',
      },
      {
        text: 'Account Name',
        value: 'we_company_name',
      },
      {
        text: 'Account No',
        value: 'we_bank.bf_account_number',
      },
      {
        text: 'Swift Code',
        value: 'we_bank.bf_swift_code',
      },
      {
        text: 'Beneficiary Bank',
        value: 'we_bank.bf_bank',
      },
      {
        text: 'Bank Adress',
        value: 'we_bank.bf_bank_address',
      },

      {
        text: 'Intermediary Bank Name',
        value: 'Intermediary Bank Name',
        show: () =>
          props.invoice.we_company.name === 'WEBEYE CLOUD TECHNOLOGY LIMITED' &&
          props.invoice.we_bank.bf_bank === 'CITIBANK N.A. HONG KONG',
        get_value() {
          console.log('asdf');
          return 'Citibank New York';
        },
      },
      {
        text: 'Intermediary Bank Swift Code',
        value: 'Intermediary Bank Swift Code',
        show: () =>
          props.invoice.we_company.name === 'WEBEYE CLOUD TECHNOLOGY LIMITED' &&
          props.invoice.we_bank.bf_bank === 'CITIBANK N.A. HONG KONG',
        get_value() {
          return 'CITIUS33';
        },
      },

      {
        text: 'Routing No',
        value: 'we_bank.bf_routing_number',
        show: () => props.invoice.we_bank.bf_routing_number,
      },
      {
        text: 'GST Reg No',
        value: 'we_company.gst_reg_number',
        show: () => props.invoice.we_company.gst_reg_number,
      },
      {
        text: 'For GST Purpose, Exchange Rate',
        value: 'For GST Purpose, Exchange Rate',
        get_value() {
          return `${get_currency_rate.value.rate}`;
        },
      },
      {
        text: 'Total amount credited excluding GST(SGD)',
        value: 'Total amount credited excluding GST(SGD)',
        get_value() {
          return `${formatNumberByNumeral(
            get_all_net_amount_before_gst.value * get_currency_rate.value.rate,
            '0,0.00'
          )}`;
        },
      },
      {
        text: 'Total GST credited (SGD)',
        value: 'Total GST credited (SGD)',
        get_value() {
          return `${formatNumberByNumeral(get_all_gst.value * get_currency_rate.value.rate, '0,0.00')}`;
        },
      },
      {
        text: 'Total amount credited including GST(SGD)',
        value: 'Total amount credited including GST(SGD)',
        get_value() {
          return `${formatNumberByNumeral(get_total_amount.value * get_currency_rate.value.rate, '0,0.00')}`;
        },
      },
      {
        text: '',
        value: '占位符',
      },
    ];
  });
  const find_tempalte_item = computed<{
    rd_we_company_name: string;
    template_type: string;
  }>(() => {
    let item = {
      rd_we_company_name: '',
      template_type: '',
    };
    if (!isEmptyData(invoice_template_list.value)) {
      if (!isEmptyData(props.invoice.we_company_name)) {
        item = invoice_template_list.value.find(
          (item) => item.rd_we_company_name === props.invoice.we_company_name
        ) as any;
      }
    }
    return item;
  });
  const find_template_detail = (logic_type: any = 0) => {
    const lt = props.logic_type || logic_type;
    return invoice_template_detail.value.find((item) => item.logic_type === lt);
  };
  const find_tempalte_logo = computed(() => {
    let rd_logo_code = '';
    if (!isEmptyData(invoice_template_detail.value)) {
      let logic_type = 0;
      if (Number(props.logic_type) !== 0) {
        logic_type = props.logic_type;
      } else {
        let bill_list = props.invoice.linked_bill_list;
        logic_type = bill_list.map((x) => x.logic_type)[0];
      }
      rd_logo_code = find_template_detail(logic_type)!.rd_logo_code;
    }
    return rd_logo_code;
  });
  const is_us = computed(() => {
    return find_tempalte_item.value.template_type === model.value.InvoiceTemplate.TEMPLATE_TYPE.US;
  });
  const is_sg = computed(() => {
    return find_tempalte_item.value.template_type === model.value.InvoiceTemplate.TEMPLATE_TYPE.SG;
  });
  const is_normal = computed(() => {
    return props.invoice.rd_property === 'Normal';
  });
  const is_prepay = computed(() => {
    return props.invoice.rd_property === 'Prepay';
  });
  // 获取汇率名称和汇率值
  const get_currency_rate = computed(() => {
    let currency_name = 'USD';
    let rate = 1;
    const currency_list = appInfo.value.currency_list;
    let month = '';
    month = invoice_table_data.value.reduce((pre, cur) => {
      if (dayjs(pre.month).isBefore(cur.month)) {
        pre = cur;
      }
      return pre;
    }).month;
    if (is_sg.value) {
      currency_name = 'SGD';
    }
    const find_currency_item = currency_list.find((item) => item.name === currency_name);
    if (is_prepay.value) {
      month = dayjs().format('YYYY-MM');
    }
    if (find_currency_item && month) {
      const find_currency_rate_item = find_currency_item.currency_rate_list.find((item) => item.month === month);
      rate = find_currency_rate_item.dollar_rate;
    }
    return {
      currency_name,
      rate,
    };
  });
  const logo_img_src = computed(() => {
    if (find_tempalte_logo.value) {
      return `${apiRoot.value}/inner_file/${find_tempalte_logo.value}`;
    }
    return '';
  });
  const invoice_title = computed(() => {
    let title = '';
    if (is_us.value) {
      if (is_normal.value) {
        title = 'Invoice';
      }
      if (is_prepay.value) {
        title = 'Bill Confirmation';
      }
    } else if (is_sg.value) {
      if (is_normal.value) {
        title = 'Tax Invoice';
      }
      if (is_prepay.value) {
        title = 'Bill Confirmation';
      }
    }
    return title;
  });
  const invoice_company_fields = computed<any[]>(() => {
    let list: string[] = [];
    if (is_us.value) {
      if (is_normal.value) {
        list = ['company_name', 'invoice_number', 'cs_address', 'date', '占位符', 'due_date'];
      }
      if (is_prepay.value) {
        list = ['company_name', 'date', 'cs_address'];
      }
    } else if (is_sg.value) {
      if (is_normal.value) {
        list = [
          'company_name',
          'invoice_number',
          'cs_address',
          'date',
          '占位符',
          'due_date',
          '占位符',
          'we_company.gst_reg_number',
        ];
      }
      if (is_prepay.value) {
        list = ['company_name', 'date', 'cs_address'];
      }
    }
    return list.map((item) => fields.value.find((f) => f.value === item)).filter((f: any) => !f.show || f.show());
  });
  const invoice_table_header = computed<Recordable[]>(() => {
    let list: string[] = [];
    if (is_us.value) {
      if (is_normal.value || is_prepay.value) {
        list = ['no', 'description', 'rd_amount'];
      }
    } else if (is_sg.value) {
      if (is_normal.value || is_prepay.value) {
        list = ['no', 'description', 'rd_net_amount_before_gst', 'gst_rate', 'rd_gst_amount'];
      }
    }
    return table_fields.filter((item) => list.includes(item.value));
  });
  const invoice_table_data = computed<Recordable[]>(() => {
    let bill_list: Recordable[] = [];
    if (!props.showBuline) {
      bill_list = props.invoice.linked_bill_list;
    } else {
      props.invoice.linked_bill_list.forEach((f) => {
        const this_linked_amount_exclude_last: number[] = [];
        function get_this_linked_amount(parent, sub, index, sub_length) {
          let amount = 0;
          if (sub_length === 1) {
            amount = parent.this_linked_amount;
          } else if (index === sub_length - 1) {
            amount =
              parent.this_linked_amount -
              this_linked_amount_exclude_last.reduce((pre, cur) => {
                pre = pre + cur;
                return pre;
              }, 0);
          } else {
            const percentage = sub.finance_invoice_money / parent.finance_invoice_money;
            amount = percentage * parent.this_linked_amount;
            this_linked_amount_exclude_last.push(amount);
          }
          if (Math.abs(amount) < 0.0000001) {
            amount = 0;
          }
          return amount;
        }
        if (!f.is_parent) {
          bill_list.push(f);
        } else {
          bill_list.push(
            ...f.sub_bill_list.map((m, index) => ({
              ...m,
              this_linked_amount: get_this_linked_amount(f, m, index, f.sub_bill_list.length),
            }))
          );
        }
      });
    }
    function get_data_item(item) {
      const detail = find_template_detail(item.logic_type)!;
      const data: Recordable = {
        description: `${detail.desc} fee of ${dayjs(item.month)
          .locale('en')
          .format('MMMM YYYY')}      ${get_buline_name(item)}`,
        month: item.month,
      };
      if (is_us.value) {
        data.amount = item.this_linked_amount;
        data.rd_amount = `${item.rd_currency_name}      ${formatNumberByNumeral(data.amount, '0,0.00')}`;
      } else if (is_sg.value) {
        data.gst_rate = `${props.invoice.tax_rate}%`;

        data.net_amount_before_gst = item.this_linked_amount / (1 + props.invoice.tax_rate / 100);
        data.rd_net_amount_before_gst = `${item.rd_currency_name}      ${formatNumberByNumeral(
          data.net_amount_before_gst,
          '0,0.00'
        )}`;

        data.gst_amount = (data.net_amount_before_gst * props.invoice.tax_rate) / 100;
        data.rd_gst_amount = `${item.rd_currency_name}      ${formatNumberByNumeral(data.gst_amount, '0,0.00')}`;
      }
      return data;
    }
    if (is_prepay.value) {
      const rd_currency_name = props.invoice.currency ? props.invoice.currency.name : 'USD';
      const detail = find_template_detail()!;
      let item: Recordable = {
        no: 1,
        description: `Prepayment for ${detail.desc} fee`,
      };
      const list: Recordable[] = [];
      if (is_us.value) {
        item = {
          ...item,
        };
        item.amount = props.invoice.it_amount;
        item.rd_amount = `${rd_currency_name}      ${formatNumberByNumeral(item.amount, '0,0.00')}`;
        list.push(item);
      } else if (is_sg.value) {
        item.gst_rate = `${props.invoice.tax_rate}%`;
        item.net_amount_before_gst = props.invoice.et_amount;
        item.rd_net_amount_before_gst = `${rd_currency_name}      ${formatNumberByNumeral(
          item.net_amount_before_gst,
          '0,0.00'
        )}`;
        item.gst_amount = props.invoice.tax_amount;
        item.rd_gst_amount = `${rd_currency_name}      ${formatNumberByNumeral(item.gst_amount, '0,0.00')}`;
        list.push(item);
      }
      return list;
    } else {
      return bill_list
        .map((item) => {
          return get_data_item(item);
        })
        .filter((f) => {
          if (is_us.value) {
            return f.amount;
          } else if (is_sg.value) {
            return f.net_amount_before_gst;
          }
          return true;
        })
        .map((item, index) => ({
          no: index + 1,
          ...item,
        }));
    }
  });
  const invoice_table_sum_fields = computed(() => {
    let fields: Recordable[] = [];
    if (is_us.value) {
      fields = [
        {
          text: 'Total Amount',
          value: `${props.invoice.currency.name}      ${formatNumberByNumeral(get_total_amount.value, '0,0.00')}`,
        },
      ];
    } else if (is_sg.value) {
      fields = [
        {
          text: 'Net amount before GST',
          value: `${props.invoice.currency.name}      ${formatNumberByNumeral(
            get_all_net_amount_before_gst.value,
            '0,0.00'
          )}`,
        },
        {
          text: 'GST',
          value: `${props.invoice.currency.name}      ${formatNumberByNumeral(get_all_gst.value, '0,0.00')}`,
        },
        {
          text: 'Total Amount',
          value: `${props.invoice.currency.name}      ${formatNumberByNumeral(get_total_amount.value, '0,0.00')}`,
        },
      ];
    }
    return fields;
  });
  const invoice_we_company_fields = computed(() => {
    let list: string[] = [];
    if (is_us.value) {
      if (is_normal.value || is_prepay.value) {
        list = [
          'we_company_name',
          'we_bank.bf_account_number',
          'we_bank.bf_swift_code',
          'we_bank.bf_bank',
          'we_bank.bf_bank_address',
          'we_bank.bf_routing_number',
        ];
      }
    } else if (is_sg.value) {
      if (is_normal.value || is_prepay.value) {
        list = [
          'we_company_name',
          'we_bank.bf_account_number',
          'we_bank.bf_swift_code',
          'we_bank.bf_bank',
          'we_bank.bf_bank_address',
        ];
      }
    }
    let ret = fields.value.filter((item) => list.includes(item.value) && (!item.show || item.show()));

    if (
      props.invoice.we_company.name === 'WEBEYE CLOUD TECHNOLOGY LIMITED' &&
      props.invoice.we_bank.bf_bank === 'CITIBANK N.A. HONG KONG'
    ) {
      ret = ret.concat(
        fields.value.filter((item) => ['Intermediary Bank Name', 'Intermediary Bank Swift Code'].includes(item.value))
      );
    }

    console.log(ret);
    return ret;
  });
  const more_fields = computed(() => {
    let list: string[] = [];
    if (is_sg.value) {
      list = [
        'For GST Purpose, Exchange Rate',
        'Total amount credited excluding GST(SGD)',
        'Total GST credited (SGD)',
        'Total amount credited including GST(SGD)',
      ];
    }
    return fields.value.filter((item) => list.includes(item.value));
  });
  const get_all_net_amount_before_gst = computed(() => {
    return invoice_table_data.value.reduce((pre, cur) => {
      pre = pre + cur.net_amount_before_gst;
      return pre;
    }, 0);
  });
  const get_all_gst = computed(() => {
    return invoice_table_data.value.reduce((pre, cur) => {
      pre = pre + cur.gst_amount;
      return pre;
    }, 0);
  });
  const get_total_amount = computed(() => {
    let total_amount = 0;
    if (is_us.value) {
      total_amount = invoice_table_data.value.reduce((pre, cur) => {
        pre = pre + cur.amount;
        return pre;
      }, 0);
    } else if (is_sg.value) {
      total_amount = get_all_net_amount_before_gst.value + get_all_gst.value;
    }
    return total_amount;
  });

  function show_dialog() {
    get_invoice_template_list().then((res) => {
      invoice_template_list.value = res;
      get_invoice_template_detail().then((res) => {
        invoice_template_detail.value = res;
        visible.value = true;
      });
    });
  }
  function get_invoice_value(item) {
    let value = '';
    if (item.value === '占位符') {
      return value;
    }
    if (item.get_value) {
      value = item.get_value();
    } else {
      let invoice_copy = cloneDeep(props.invoice);
      const fields = item.value.split('.');
      value = fields.reduce((pre, cur) => {
        pre = invoice_copy[cur];
        invoice_copy = pre;
        return pre;
      }, invoice_copy);
    }
    if (isEmptyData(value)) {
      value = '-';
    }
    return value;
  }
  function get_buline_name(bill) {
    let buline = '';
    if (!props.showBuline) {
      return buline;
    }
    if (['GCP', 'GcpSupport', 'AWS', 'GSuite'].includes(bill.rd_buline_name)) {
      buline = bill.rd_buline_name;
    } else if (bill.rd_buline_name === 'FbSA') {
      buline = 'Facebook';
    } else if (['GoogleCEP', 'GoogleSA'].includes(bill.rd_buline_name)) {
      buline = 'Google';
    } else if (bill.rd_buline_name === 'TiktokCEP') {
      buline = 'Tiktok';
    } else if (bill.rd_buline_name === 'TwitterSA') {
      buline = 'Twitter';
    } else if (bill.rd_buline_name === 'DSP') {
      buline = 'DSP';
    } else if (bill.rd_buline_name === 'AppMeta') {
      buline = 'AppMeta';
    } else if (!isEmptyData(bill.rd_buline_name)) {
      buline = bill.rd_buline_name.toLowerCase();
      buline = buline.charAt(0).toUpperCase() + buline.slice(1);
    } else {
      buline = '';
    }
    return buline;
  }
  function save_invoice_pdf() {
    const outPutPdfRes = outPutPdf('invoice', 'pdf_wrapper')!;
    visible.value = false;
    outPutPdfRes.then((res: any) => {
      const reader = new FileReader();
      reader.readAsDataURL(res);
      reader.onload = function (e) {
        add_pdf({
          to_reopen: !isEmptyData(props.neutralize_reason),
          invoice_id: props.invoice.id,
          pdf: e.target?.result,
        }).then((res) => {
          emit('add_pdf_done', res);
        });
      };
    });
  }

  expose({
    show_dialog,
  });

return (_ctx: any,_cache: any) => {
  const _component_AModal = _resolveComponent("AModal")!

  return (_openBlock(), _createBlock(_component_AModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    centered: "",
    closable: false,
    maskClosable: "",
    width: 1184,
    wrapClassName: "invoice_pdf_dialog_container",
    title: "自动开票",
    onOk: save_invoice_pdf
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: "pdf_wrapper",
        class: _normalizeClass({ pdf_wrapper: true, sg_pdf_wrapper: _unref(is_sg), us_pdf_wraper: _unref(is_us) })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(logo_img_src),
            alt: "",
            srcset: ""
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.invoice.we_company_name), 1),
          _createElementVNode("div", null, _toDisplayString(__props.invoice.we_address), 1)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(invoice_title)), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoice_company_fields).filter((_f, index) => index % 2 === 0), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: "invoice_company_item mb-12"
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.text) + _toDisplayString(item.text ? ':' : ''), 1),
                _createElementVNode("span", {
                  style: _normalizeStyle(item.style ? item.style : {})
                }, _toDisplayString(get_invoice_value(item)), 5)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoice_company_fields).filter((_f, index) => index % 2 !== 0), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: "invoice_company_item mb-12"
              }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(item.text) + _toDisplayString(item.text ? ':' : ''), 1),
                _createElementVNode("span", {
                  style: _normalizeStyle(item.style ? item.style : {})
                }, _toDisplayString(get_invoice_value(item)), 5)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoice_table_header), (header) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: header.text,
                    style: _normalizeStyle({ width: header.width ? header.width : 'auto' })
                  }, _toDisplayString(header.text), 5))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoice_table_data), (data, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoice_table_header), (header) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: header.text,
                      class: "save_space"
                    }, _toDisplayString(data[header.value]), 1))
                  }), 128))
                ]))
              }), 128))
            ]),
            _createElementVNode("tfoot", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoice_table_sum_fields), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.text
                }, [
                  _createElementVNode("td", {
                    colspan: _unref(invoice_table_header).length - 1,
                    style: {"text-align":"right"}
                  }, _toDisplayString(item.text), 9, _hoisted_13),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "invoice_we_company_detail_seal mb-48 item",
          style: _normalizeStyle(_unref(isEmptyData)(_unref(more_fields)) ? { 'margin-top': '144px' } : {})
        }, [
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoice_we_company_fields), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: "invoice_we_company_item mb-12"
              }, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(item.text) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(get_invoice_value(item)), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              (__props.invoice.sealBase64Data)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: 'data:image/png;base64,' + __props.invoice.sealBase64Data,
                    alt: ""
                  }, null, 8, _hoisted_20))
                : _createCommentVNode("", true)
            ])
          ])
        ], 4),
        (!_unref(isEmptyData)(_unref(more_fields)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(more_fields), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.value,
                    class: "invoice_company_item mb-12"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.text) + ":", 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(more_fields), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.value,
                    class: "invoice_company_item mb-12"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(get_currency_rate).currency_name), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(more_fields), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.value,
                    class: "mb-12"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(get_invoice_value(item)), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(is_prepay))
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Please kindly remark the " + _toDisplayString(__props.invoice.invoice_number) + " in remittance advice. ", 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})